/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FaxFilterOptionsResponse } from './FaxFilterOptionsResponse';
import {
    FaxFilterOptionsResponseFromJSON,
    FaxFilterOptionsResponseFromJSONTyped,
    FaxFilterOptionsResponseToJSON,
    FaxFilterOptionsResponseToJSONTyped,
} from './FaxFilterOptionsResponse';

/**
 * 
 * @export
 * @interface FindFaxFilterOptions200Response
 */
export interface FindFaxFilterOptions200Response {
    /**
     * 
     */
    data?: FaxFilterOptionsResponse;
}

/**
 * Check if a given object implements the FindFaxFilterOptions200Response interface.
 */
export function instanceOfFindFaxFilterOptions200Response(value: object): value is FindFaxFilterOptions200Response {
    return true;
}

export function FindFaxFilterOptions200ResponseFromJSON(json: any): FindFaxFilterOptions200Response {
    return FindFaxFilterOptions200ResponseFromJSONTyped(json, false);
}

export function FindFaxFilterOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindFaxFilterOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FaxFilterOptionsResponseFromJSON(json['data']),
    };
}

export function FindFaxFilterOptions200ResponseToJSON(json: any): FindFaxFilterOptions200Response {
    return FindFaxFilterOptions200ResponseToJSONTyped(json, false);
}

export function FindFaxFilterOptions200ResponseToJSONTyped(value?: FindFaxFilterOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FaxFilterOptionsResponseToJSON(value['data']),
    };
}

